import { Image } from '@cian/ui-kit';
import { IconPlaceholderImage16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchFavoriteEntities } from '../../actions/favoriteEntities';
import { selectFolder } from '../../actions/folders/actions';
import { unselectAll } from '../../actions/selected';
import { FoldersListItem } from '../../components/FoldersList/FoldersListItem';
import { addQueryToHistory } from '../../hooks/browserHistory';
import { selectSelectedId } from '../../selectors/folders';
import { IFavoritesFolder } from '../../types/favoriteEntity';

interface IFoldersListItemContainerProps {
  folder: IFavoritesFolder;
}

export function FoldersListItemContainer({ folder }: IFoldersListItemContainerProps) {
  const dispatch = useDispatch();
  const selectedFolderId = useSelector(selectSelectedId);

  const { imageUrl } = folder;
  const image = imageUrl ? (
    <Image src={imageUrl} width={48} height={48} alt="Фото подборки" objectFit="cover" />
  ) : (
    <IconPlaceholderImage16 color="gray20_100" />
  );

  const handleClick = () => {
    if (folder.id !== selectedFolderId) {
      addQueryToHistory({ folder: `${folder.id}` });
      dispatch(selectFolder({ folder }));
      dispatch(unselectAll());
      dispatch(fetchFavoriteEntities({ offset: 0 }));
    }
  };

  return (
    <FoldersListItem
      image={image}
      selected={folder.id === selectedFolderId}
      title={folder.name}
      description={folder.description}
      onClick={handleClick}
    />
  );
}
